import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface IFrameEvent {
  type: string;
  from: 'parent' | 'child';
  msg?: IFrameMsg;
}

export interface IFrameMsg {
  id: string;
  name: string;
  link: string;
}

@Injectable({
  providedIn: 'root'
})
export class IFrameService {
  constructor() { }

  private messageSource = new Subject<IFrameEvent>();
  public iframeMessage$ = this.messageSource.asObservable();

  public emitMessage(value: IFrameEvent) {
    this.messageSource.next(value);
  }

}
